

const GestaoMembros = () => {

    const us_codigo = sessionStorage.getItem('us_codigo')

    return (

        <div style={{ width: "100%", height: "100vh" }}>
        <iframe
            src={`https://housekeeper.hospitaissaudaveis.org/?token=1234X&user=${us_codigo}`}
            width="100%"
            height="100%"
            frameBorder="0"
            allowFullScreen
            title="House Keepr"
        />
        </div>

    )

}

export default GestaoMembros;